export const AUTH_BROADCAST_CHANNEL = 'auth-events';

export const authChannel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
